import {isPlatformBrowser, NgClass} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {ModalComponent} from '../oex-ui-kit/components/modal/modal.component';
import {ModalService} from '../oex-ui-kit/services/modal.service';
import {AlertContainerComponent} from '../oex-ui-kit/components/alert/alert-container.component';
import {AlertService} from '../oex-ui-kit/services/alert.service';
import {AuthService} from './services/auth.service';

const ACTIVATION_ALERT_LEARN_MORE_URL =
  'https://community.intersystems.com/post/how-earn-points-intersystems-global-masters-advocate-hub';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    ModalComponent,
    NgClass,
    AlertContainerComponent
  ],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
  protected readonly ms = inject(ModalService);
  private readonly auth = inject(AuthService);
  private readonly alerts = inject(AlertService);
  private readonly platformId = inject(PLATFORM_ID);

  ngOnInit() {
    this.showActivationAlertIfNeeded();
  }

  // Show the "Account Activated!" alert once to newly-arrived members
  // (those asked to complete the activation challenge, welcome_status === 'welcome')
  private showActivationAlertIfNeeded() {
    if (!isPlatformBrowser(this.platformId) || this.auth.user.welcome_status !== 'welcome') {
      return;
    }

    const seenKey = `gm-activation-alert-seen-${this.auth.user.id}`;
    try {
      if (localStorage.getItem(seenKey)) {
        return;
      }
    } catch {
      // localStorage unavailable (e.g. private mode) — still show the alert
    }

    this.alerts.show({
      title: 'Account Activated!',
      openLinksInNewTab: true,
      message:
        'If you\'ve already completed eligible activities on the Developer Community, Open Exchange, ' +
        'or other InterSystems developer platforms, points for those activities will be awarded automatically **within 2 days**.\n\n' +
        `Learn more about how this works and how to earn points for activities outside Global Masters [here](${ACTIVATION_ALERT_LEARN_MORE_URL}).`,
      // Persist "seen" only when the user actually closes the alert
      onClose: () => this.markActivationAlertSeen(seenKey)
    });
  }

  private markActivationAlertSeen(seenKey: string) {
    try {
      localStorage.setItem(seenKey, '1');
    } catch {
      // localStorage unavailable — nothing to persist
    }
  }
}
